import { style } from 'typestyle';
import * as React from 'react';
import {TabStyles} from '@tableau/widgets';
import {ATTENTION_COLOR} from '../../settings/styles/CommonStyles';

export const textWidgetStyle: string = style(
  {
    display: 'flex', flexDirection: 'column', width: '100%'
  }
);

export const successStyle: string = style(
  {
    color: TabStyles.Colors.Black, textAlign: 'center', fontSize: '20px', fontWeight: 'normal'
  }
);

export const warningStyle: string = style(
  {
    color:TabStyles.Colors.AttentionLight, textAlign: 'center', padding:'6px'
  }
);

export const internalTextFieldStyle: React.CSSProperties = {
  marginBottom: 6, width: '100%'
};